export const pageSize = 10;
export const searchPageSize = 10;
export const MAX_CONTENT_WIDTH = 1000; // this sets the window of width of container for web.
